<template>
  <div class="vc-contabil-banner">
    <div class="content-left">
      <img
        style="width: 24px"
        class="hidden-sm-and-down"
        :src="logo"
        alt="logo contabil"
      />
      <span>
        <F360HtmlRenderer :html="defineButton.primaryText" />
      </span>
    </div>
    <div class="content-right">
      <el-button class="banner-button" @click="handleLink">
        <span class="banner-button__label">
          {{ defineButton.btnText }}
          <MaterialIcon class="banner-button__icon" icon="arrow_outward" />
        </span>
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from "@/ui/assets/f360-icon-green.png";
import F360HtmlRenderer from "@/ui/components/Html/F360HtmlRenderer.vue";
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import {
  BannerContabilStatus,
  EBannerContabilStorageKey,
  EMapperStatusBannerContabil
} from "@/core/composables/BannersHandlers/BannerContabil/types";
import { computed, onMounted, ref } from "vue";

const status = ref(BannerContabilStatus.terceiro);

const defineButton = computed(() => EMapperStatusBannerContabil[status.value]);

const emits = defineEmits(["CBannerClick", "CBannerVisualizar"]);

const handleLink = () => {
  emits("CBannerClick", defineButton.value);
};

const obterStatus = () => {
  return localStorage.getItem(EBannerContabilStorageKey.BannerContabilStatus);
};

const setStatus = (val: BannerContabilStatus) => {
  return localStorage.setItem(
    EBannerContabilStorageKey.BannerContabilStatus,
    val.toString()
  );
};

const handleStatus = () => {
  const hasStatus = obterStatus();

  if (!hasStatus) {
    status.value = BannerContabilStatus.primeiro;
    setStatus(BannerContabilStatus.primeiro);
  } else {
    status.value = Number(hasStatus);
  }
};

const handleShowBanner = () => {
  handleStatus();

  emits("CBannerVisualizar");
};

const updateStatus = () => {
  const hasStatus = obterStatus();

  const statusAtual = Number(hasStatus);

  if (statusAtual >= 5) {
    status.value = BannerContabilStatus.primeiro;
    setStatus(BannerContabilStatus.primeiro);

    return;
  }

  setStatus(statusAtual + 1);

  status.value = statusAtual + 1;
};

onMounted(() => {
  try {
    updateStatus();
  } finally {
    handleShowBanner();
  }
});
</script>

<style lang="scss" scoped>
@use "@/ui/styles/theme/f360-theme" as *;
@use "@/ui/styles/variables" as *;
@import url("./style.scss");
</style>
